<div class="modal-header">
    <h2 class="modal-title" translate>lblDocumentWarningsAndRemarks</h2>
    <button type="button" class="close" aria-label="Close" (click)="OnClose()">
        <span aria-hidden="true">×</span>
    </button>
</div>
<div class="modal-body p-0 min-h500">
    <div class="popup-vcenter">
        <div class="card pad15">
            <div class="form-row">
                <div class="col-3">
                    <div class="af-form-group">
                        <label>
                          <span translate>lblWoNo</span>
                        </label>
                        <div class="lbl-info">
                          <span class="lbl-info" *ngIf="appointmentDetails.workOrderNo;else load_WoNoelse">#
                            {{appointmentDetails.workOrderNo}}</span>
                          <ng-template #load_WoNoelse>
                            <span class="lbl-info" translate>-</span>
                          </ng-template>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="af-form-group">
                        <label>
                          <span translate>lblRegNumber</span>
                        </label>
                        <div class="lbl-info">
                          <div class="flmid flex-wrap">
                            <div class="licplate LPNo d-flex">
                              <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                              {{appointmentDetails.licensePlate}}
                            </div>
                            <div class="imgWid">
                                <img af-brand-logo [data-code]="appointmentDetails.brandCode" data-type="BRAND"
                                  class="{{appointmentDetails.brandCode}}-icon common"
                                  [title]="appointmentDetails.brandCode" class="brandicon" alt="img" />
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="af-form-group">
                        <label translate>lblVinNumber</label>
                        <div class="lbl-info">
                          {{appointmentDetails.chassisNo}}
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="af-form-group">
                        <label>
                          <span translate>lblCustomer</span> / <span translate>lblOwner</span>
                        </label>
                        <div class="input-group">
                            <ng-multiselect-dropdown
                              style="width: 100%"
                              [settings]="dropdownSettings"
                              [data]="groupedDemandList"
                              placeholder="{{ 'lblBillToCustomer' | translate }}"
                              [(ngModel)]="selectedCustomers"
                            >
                            </ng-multiselect-dropdown>
                          </div>
                      </div>
                </div>
            </div>
            <div class="form-row">
                <ng-cotainer *ngIf="generatedResponse">
                    <div class="col-12">
                        <div class="alert alert-warning font15 text-center p-2 m-0">{{generatedResponse}}</div>
                    </div>
                </ng-cotainer>
            </div>
        </div>
        <div class="card pad15">
            <div class="col-12 mb15">
                <div class="d-flex align-items-center mb-2">
                    <h4 class="title16 text-uppercase" translate>lblDocumentWarnings</h4>
                </div>
                <!-- border-bottom tableMx-15 -->
                <div class="table-responsive border">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th scope="col" translate>lblLineType</th>
                                <th scope="col" translate>lblNo</th>
                                <th scope="col" translate>lblDescription</th>
                                <th scope="col" translate>lblCategory</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container
                                *ngIf="documentWarnings?.length>0; else load_else">
                                <ng-container
                                    *ngFor="let warning of documentWarnings; let i=index">
                                    <tr [ngStyle]="{'color': warning.category === 'Error' ? '#f12e05' : ''}">
                                        <td>{{warning.lineType}}</td>
                                        <td>{{warning.no}}</td>
                                        <td>{{warning.description}}</td>
                                        <td>{{warning.category}}</td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card pad15">
            <div class="col-12 mb15">
                <div class="d-flex align-items-center mb-2">
                    <h4 class="title16 text-uppercase" translate>lblServiceRemarks</h4>
                </div>
                <!-- border-bottom tableMx-15 -->
                <div class="table-responsive border">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th scope="col" translate>lblSourceType</th>
                                <th scope="col" translate>lblDescription</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container
                                *ngIf="serviceRemarks?.length>0; else load_else">
                                <ng-container
                                    *ngFor="let remark of serviceRemarks; let i=index">
                                    <tr>
                                        <td>{{remark.sourceType}}</td>
                                        <td>{{remark.description}}</td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
       
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" aria-label="Center Align" [ngClass]="{'disable ': !isAllowToGenerate}" (click)="onPreviewInvoice(previewModal)"
        translate>lblPreviewInvoice</button>
    <button type="button" class="btn btn-primary" aria-label="Center Align" [ngClass]="{'disable ': !isAllowToGenerate}" (click)="OnGenerateInvoice()"
        translate>lblGenerateInvoice</button>
    <button type="button" class="btn btn-secondary"  aria-label="Center Align" (click)="OnClose()"
        translate>lblClose</button>
</div>
<ng-template #previewModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>Invoice Preview - {{ appointmentDetails.workOrderNo }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body" style="max-height: 80vh !important;">
        <div *ngIf="trustedBlobUrl">
            <iframe id="fraDisabled" [src]="trustedBlobUrl" width="100%" height="700px" frameborder="0"></iframe>
          </div>
    </div>
</ng-template>